import React, { Suspense, lazy } from 'react';
import ReactOnRails from 'react-on-rails/client';

const lazyComponent = (Component) => (props) =>
  React.createElement(
    Suspense,
    {
      fallback: React.createElement('div', {
        className: 'loading-placeholder',
        style: { minHeight: '100px' },
      }),
    },
    React.createElement(Component, props)
  );

// Lazy: pulls in third-party SDKs or page-specific code only when mounted.
const GoogleMapsApi = lazy(() => import('bundles/Components/GoogleMapsApi'));
const StripeCheckout = lazy(() => import('bundles/Components/StripeCheckout'));
const EventCategories = lazy(() => import('bundles/Events/components/EventCategories'));

ReactOnRails.register({
  GoogleMapsApi: lazyComponent(GoogleMapsApi),
  StripeCheckout: lazyComponent(StripeCheckout),
  EventCategories: lazyComponent(EventCategories),
});
